"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const partners = [{
  name: "Denver Foundation",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/partner_denver_foundation.png",
  url: "#"
}, {
  name: "Colorado Health Foundation",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/partner_colorado_health.png",
  url: "#"
}, {
  name: "Wells Fargo",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/partner_wells_fargo.png",
  url: "#"
}, {
  name: "Comcast NBCUniversal",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/partner_comcast.png",
  url: "#"
}, {
  name: "Xcel Energy",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/partner_xcel_energy.png",
  url: "#"
}, {
  name: "Western Union",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/partner_western_union.png",
  url: "#"
}, {
  name: "Latino Community Foundation",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/partner_latino_community.png",
  url: "#"
}, {
  name: "Target",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/partner_target.png",
  url: "#"
}];
export default function CommunityPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="community-partners" ref={ref} className={cn("w-full py-24 bg-muted/40 transition-opacity duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-primary mb-6">
            Our Network of Impact
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            We are proud to collaborate with leading organizations dedicated to
            expanding economic opportunity and advancing prosperity for
            Colorado’s Hispanic community.
          </p>
        </div>

        <div className="relative px-8 md:px-12">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-8">
              {partners.map((partner, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-8 basis-1/2 md:basis-1/3 lg:basis-1/5">
                  <div className="group flex items-center justify-center h-32 p-6 bg-white rounded-xl shadow-sm border border-border/50 hover:shadow-md transition-all duration-300">
                    <img src={partner.logo} alt={`${partner.name} logo`} className="max-h-16 w-auto object-contain filter grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" />
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-4 lg:-left-12 border-primary/20 text-primary hover:bg-primary hover:text-white" />
            <CarouselNext className="hidden md:flex -right-4 lg:-right-12 border-primary/20 text-primary hover:bg-primary hover:text-white" />
          </Carousel>
        </div>

        <div className="mt-16 text-center">
          <p className="text-muted-foreground mb-6">
            Interested in becoming a partner?
          </p>
          <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary hover:text-white group">
            <Link to="/PartnersPage">
              Join Our Network
              <ArrowRight className="ml-2 size-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}